import * as React from 'react'

const SvgElephantSpanner = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={170}
    height={120}
    viewBox="0 0 170 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#ElephantSpanner_svg__a)">
      <path
        d="M145.859 1.937s11.118 27.393-8.582 29.822c-4.042.496-8.058-5.093-10.587-9.149a10.417 10.417 0 0 0-8.84-4.912l-18.37-.009 11.331 31.069c-20.082 11.516-45.546 2.968-51.245-14.096-22.718 8.755-14.613 32.144-29.964 32.144-6.12 0-9.653-.523-9.653-.523l-1.1 5.153s12.631 6.347 21.361.27L33.665 120h19.912L64.79 99.45c1.967-3.606 5.971-5.576 10-4.92l27.27 4.424L112.503 120h23.946l-20.614-57.494c.229.026 7.846.848 12.462-1.919l-8.335-7.444s48.852 5.26 39.876-46.906L145.859 1.94v-.004Z"
        fill="#7130C9"
      />
      <path
        d="m117.79 67.95 13.656 7.122a10.906 10.906 0 0 1 5.831 9.752l-.136 18.357h-6.719L117.79 67.949ZM64.79 99.446l-2.797 5.123 10.464 15.427H97.24L86.283 96.388 74.79 94.525c-4.03-.655-8.037 1.315-10 4.921ZM110.564 48.899c.085-.047.166-.099.251-.146-16.83 6.18-35.302-1.336-43.382-16.913-1.879.433-7.867 2.814-7.867 2.814 5.674 16.994 30.954 25.543 50.998 14.24v.005Z"
        fill="#440A78"
      />
      <path
        d="M60.373 31.626s.026-.009.043-.013c-.013 0-.025.009-.043.013ZM66.897 31.921l.043-.012c-.013 0-.025.008-.043.012Z"
        fill="#7130C9"
      />
      <path
        d="M65.537 27.501a35.742 35.742 0 0 0 1.9 4.339c8.076 15.573 26.551 23.094 43.382 16.913l-11.17-30.88a2.702 2.702 0 0 0-3.468-1.627L65.537 27.5Z"
        fill="#9865FC"
      />
      <path
        d="M18.849 71.427.288 60.536c-.455-.266-.349-.951.165-1.058 4.952-1.007 20.878-3.542 19.679 5.816l-1.284 6.133Z"
        fill="#440A78"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m136.16 3.358-3.405-.42c1.955-3.104 6.949-3.276 8.688 1.029l19.878 2.44.153-.213c1.636-2.266 4.828-2.694 6.987-.917.821.677 1.161 1.298 1.539 2.236l-4.28-.523-1.445 1.936.943 2.227 4.281.527c-1.956 3.105-6.95 3.277-8.688-1.028l-18.497-2.274-1.377-.171-.153.214a4.825 4.825 0 0 1-6.988.916c-.82-.676-1.16-1.297-1.538-2.235l2.962.364.447.055a2.096 2.096 0 0 0 2.231-1.43h.042l.047-.381c.14-1.165-.676-2.215-1.815-2.352h-.012Z"
        fill="#FFC103"
      />
      <path
        d="M121.382 32.654a3.345 3.345 0 0 0-3.367-3.324c-1.84.018-3.315 1.538-3.298 3.392a11.195 11.195 0 0 1 6.665-.068Z"
        fill="#fff"
      />
      <path
        d="M113.451 117.379c.017-4.728 6.762-4.669 6.995 0h-1.045c.102-5.234 7.548-5.165 7.808 0h-1.798a3.921 3.921 0 0 1 1.22-2.895c2.384-2.335 6.702-.506 6.154 2.895-.021.094-.157.094-.174 0-.37-2.253-3.222-3.392-4.748-1.653a2.59 2.59 0 0 0-.654 1.7c-.068 1.186-1.794 1.139-1.798-.047-.038-3.392-4.82-3.272-4.965.043-.038.689-1.062.651-1.045-.043.123-2.484-2.988-3.838-4.777-2.124a3.103 3.103 0 0 0-.999 2.124c0 .107-.174.107-.174 0ZM35.735 117.379c.004-4.326 6.167-4.262 6.397 0h-1.063c.064-4.827 6.979-4.758 7.213 0h-1.798a3.629 3.629 0 0 1 1.13-2.681c2.198-2.146 6.193-.45 5.636 2.681-.021.094-.153.09-.174 0-.365-1.987-2.89-2.99-4.229-1.439-.37.415-.553.946-.565 1.495-.077 1.186-1.794 1.13-1.798-.056-.03-2.998-4.22-2.861-4.352.056-.047.702-1.088.646-1.063-.056.128-2.219-2.652-3.426-4.25-1.906a2.79 2.79 0 0 0-.91 1.906c0 .107-.174.107-.174 0Z"
        fill="#440A78"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M140.924 8.211c-.106 2.099 2.763 2.578 5.181 2.608 1.819.026 3.6-.51 5.134-1.499 2.134-1.374 5.696-3.306 8.599-3.092-4.259-10.026-18.468-6.904-18.914 1.983Z"
        fill="#7130C9"
      />
    </g>
    <defs>
      <clipPath id="ElephantSpanner_svg__a">
        <path fill="#fff" d="M0 0h170v120H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgElephantSpanner
